import { Subject } from 'rxjs';
import EventParams = jwplayer.EventParams;
import {
  fcPlayerEventMap,
  PixelsVideoEvent
} from '../../../constants/Video';

export const fcPlayer$ = (player: any, pageId: string) => {
  const sub = new Subject<[string, Record<string, any>]>();
  const firstFrameSignal = ((fn: (x: any) => void) => {
    let sent = false;
    return (reset: boolean) => {
      if (reset) {
        sent = false;
        return;
      }

      if (sent) return;

      sent = true;
      fn(player);
    };
  })((bc: any) => {
    const {
      duration: videoDuration,
      id: videoId,
      campaignId
    } = bc?.mediainfo || {};
    const payload = {
      campaignId: campaignId || '',
      pageId,
      videoId,
      videoDuration,
      integrationType: 'hero'
    };
    sub.next([PixelsVideoEvent.FIRST_FRAME, payload]);
    sub.next([PixelsVideoEvent.VIDEO_BEFORE_PLAY, payload]);
  });

  // work around for missing the first `loadedmetadata` because when the player is being
  // passed to us, the event has been fired
  player.on(fcPlayerEventMap.get(PixelsVideoEvent.AD_REQUEST), (e: any) => {
    const { id } = e.target.player.mediainfo;
    sub.next([PixelsVideoEvent.VIDEO_BEFORE_PLAY, {
      videoId: id
    }]);
  });

  for (const [key, value] of fcPlayerEventMap.entries()) {
    player.on(value as keyof EventParams, (event: any) => {
      switch (value) {
        case fcPlayerEventMap.get(PixelsVideoEvent.AD_1ST_QUARTILE):
        case fcPlayerEventMap.get(PixelsVideoEvent.AD_MID_POINT):
        case fcPlayerEventMap.get(PixelsVideoEvent.AD_3RD_QUARTILE):
        case fcPlayerEventMap.get(PixelsVideoEvent.AD_ENDED): {
          const { duration, currentTime } = event.target?.player?.ads?.ad || {};
          if (duration && currentTime) {
            sub.next([key, {
              duration,
              position: currentTime
            }]);
          }
          break;
        }
        case fcPlayerEventMap.get(PixelsVideoEvent.AD_STARTED): {
          const { duration } = event.target?.player?.ads?.ad || {};
          if (duration) {
            sub.next([key, {
              duration,
              position: 0
            }]);
          }
          break;
        }
        case fcPlayerEventMap.get(PixelsVideoEvent.BEFORE_COMPLETE): {
          firstFrameSignal(true);
          // forward the beforeComplete
          sub.next([key, event]);
          break;
        }
        case fcPlayerEventMap.get(PixelsVideoEvent.TIME): {
          const { duration } = event.target?.player?.mediainfo || {};
          firstFrameSignal(false);
          sub.next([key, {
            duration,
            position: player.currentTime()
          }]);
          break;
        }
        default:
          sub.next([key, event]);
      }
    });
  }
  return sub;
};